// Rapor türü — Geçmiş Rapor Aktarımı toplu ekranının "Tür" alanı (UX paketi 2026-10-01).
//
// Alan serbest metindi ve kapak önerisi bazen kapak başlığını olduğu gibi yazıyordu
// ("YÖNETİM KURULU FAALİYET RAPORU"). Artık sabit liste: kullanıcı `<select>`'ten seçer,
// kapaktan gelen ham etiket `normalizeReportType` (utils/report-type.ts) ile bu id'lerden
// birine indirilir, eşleşmezse alan boş kalır (✦ konmaz).
//
// SAKLAMA: `report_imports.report_type varchar(40)` serbest metin olarak KALIR; yazılan
// değer `REPORT_TYPE_LABELS[id]`'dir (DB/DTO şekli değişmez, eski satırlar okunur durur).
import { z } from "zod";

export const REPORT_TYPES = ["faaliyet", "entegre", "gri", "tsrs", "diger"] as const;
export const ReportType = z
  .enum(REPORT_TYPES)
  .describe("Rapor türü: faaliyet · entegre · gri · tsrs · diger.");
export type ReportType = z.infer<typeof ReportType>;

export const REPORT_TYPE_LABELS: Record<ReportType, string> = {
  faaliyet: "Faaliyet Raporu",
  entegre: "Entegre Faaliyet Raporu",
  gri: "Sürdürülebilirlik Raporu (GRI)",
  tsrs: "TSRS Raporu",
  diger: "Diğer",
};
